import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { ArrowRight, Calendar, FileText, BedDouble } from "lucide-react";

const AirbnbModule = () => (
  <div className="min-h-screen bg-background">
    <Navbar />
    <main className="container-page py-16">
      <div className="tiny-label mb-3">Pro Airbnb &amp; ubytování</div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 max-w-3xl leading-[1.05]">
        Povlečení, ručníky, prostěradla – <span className="text-sky-600">vyřešíme za vás</span>.
      </h1>
      <p className="mt-5 text-slate-600 max-w-2xl">
        Pravidelné svozy pro Airbnb, Booking, penziony a malé hotely. Mnoho adres, jeden přehled, jedna měsíční faktura.
      </p>

      <div className="mt-10 grid md:grid-cols-3 gap-5">
        {[
          { icon: BedDouble, title: "Více adres v jednom účtu", desc: "Spravujte 1 nebo 50 apartmánů – vše na jedné platformě." },
          { icon: Calendar, title: "Pravidelné svozy", desc: "Týdenní nebo na míru. Nastavíte jednou a my přijíždíme automaticky." },
          { icon: FileText, title: "Měsíční fakturace", desc: "Souhrnná faktura s rozpisem na jednotky. Export do PDF i Excelu." },
        ].map((f) => (
          <Card key={f.title} className="p-6">
            <div className="w-11 h-11 rounded-xl bg-sky-100 text-sky-700 grid place-items-center mb-3"><f.icon className="w-5 h-5" /></div>
            <h3 className="font-display font-bold">{f.title}</h3>
            <p className="text-sm text-slate-600 mt-1">{f.desc}</p>
          </Card>
        ))}
      </div>

      <div className="mt-12">
        <Link to="/registrace?role=customer" className="cta-primary" data-testid="airbnb-cta">
          Začít s firemním účtem <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </main>
    <Footer />
  </div>
);

export default AirbnbModule;
